import Image from "next/image";
import Button from "./Inputs/Button";
import {track} from "../analytics";

export default function ProviderExplainerBanner({
    title, text, logo, name, url, bgImageDesktop, bgImageMobile,
    bgImageDesktopHeight, bgImageDesktopWidth, bgImageMobileHeight, bgImageMobileWidth, logoHeight, logoWidth, logoHeightMobile, logoWidthMobile, sponsored
}) {

    const handleClick = (e) => {
        e.stopPropagation()
        track("Click", { category: "Provider Explainer Banner", label: name });
        window.open(url, '_blank')
    }

    return (
        <div
            className={'w-[calc(100%+16px)] -mx-2 xs:mx-0 xs:w-full relative bg-primary-blue cursor-pointer'}
            onClick={handleClick}>
            <div className="grid grid-cols-12 [&_*]:text-white h-full gap-2">
                <div className={'col-span-12 sm:col-span-7 h-full flex flex-col'}>
                    <div
                        className={'flex flex-col h-full justify-between align-middle p-4 xs:p-8 box-border'}>
                        <div
                            className={'font-bold max-[300px]:text-xl max-[400px]:text-2xl text-3xl pb-4'}>{title}</div>
                        <div className={'sm:pb-10 max-[300px]:text-[14px] text-[1.2rem]'}>{text}</div>
                        { sponsored && (
                            <div className={'flex sm:hidden justify-center relative p-0 my-4'}>
                                <div
                                    className={'w-full h-full flex justify-center relative m-0'}>
                                    <Image
                                        src={bgImageMobile}
                                        alt='Provider Explainer banner mobile image'
                                        className='self-center w-full'
                                        height={bgImageMobileHeight}
                                        width={bgImageMobileWidth}
                                    />
                                </div>
                            </div>
                        )}
                        <div className={'flex justify-between flex-wrap'}>
                            <div className={'self-end pt-2 xs:pt-0'}>
                                <Button
                                    text='Download'
                                    className={'bg-mint-green xs:px-14 max-w-56 w-full h-full py-2.5 box-border text-center'}
                                    onClick={handleClick}
                                    dataTest="provider-explainer-download-button"
                                />
                            </div>
                            { sponsored && (
                                <div className={'self-end  flex flex-col relative justify-end items-end pt-2 xs:pt-0 pb-0 px-0 box-border'}>
                                    <div className={'self-start py-1 px-0 max-[300px]:text-[14px] text-[1.1rem] leading-[1.1rem] max-[300px]:leading-[14px]'}>Supported by</div>
                                    <div className={'self-start hidden xs:flex'}>
                                        <Image
                                            src={logo}
                                            alt='logo'
                                            className={'self-start justify-start ml-1.5'}
                                            objectFit={'scale-down'}
                                            height={logoHeight}
                                            width={logoWidth}
                                        />
                                    </div>
                                    <div className={'self-start xs:hidden flex'}>
                                        <Image
                                            src={logo}
                                            alt='logo'
                                            className={'self-start justify-start'}
                                            objectFit={'scale-down'}
                                            height={logoHeightMobile}
                                            width={logoWidthMobile}
                                        />
                                    </div>
                                </div>
                            )}
                            {!sponsored && (
                                <div className={'flex sm:hidden justify-center relative p-0 m-0 mt-4'}>
                                    <div
                                        className={'w-full h-full flex justify-center relative m-0'}>
                                        <Image
                                            src={bgImageMobile}
                                            alt='Provider Explainer banner mobile image'
                                            className='self-center w-full'
                                            height={bgImageMobileHeight}
                                            width={bgImageMobileWidth}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={'hidden sm:col-span-5 sm:flex justify-center p-0'}>
                    <div
                        className={'w-full h-full flex justify-end relative [&>span]:md:!my-4'}>
                        <Image
                            src={bgImageDesktop}
                            alt='Provider Explainer banner background image'
                            objectFit='contain'
                            objectPosition='center right'
                            priority
                            height={bgImageDesktopHeight}
                            width={bgImageDesktopWidth}
                        />
                    </div>
                </div>
            </div>


        </div>
    )
}